import { MS_PER_SECOND } from './auth.constants';

export const secondsUntil = (deadline: number, now: number): number =>
  Math.max(0, Math.ceil((deadline - now) / MS_PER_SECOND));

export type InactivityCheck =
  { kind: 'timeout' } | { kind: 'wait'; isWarning: boolean; nextCheckInMs: number };

interface InactivityCheckInput {
  deadline: number;
  now: number;
  warningMs: number;
  isWarning: boolean;
}

export const checkInactivity = (input: InactivityCheckInput): InactivityCheck => {
  const { deadline, now, warningMs } = input;
  const remainingMs = deadline - now;
  if (remainingMs <= 0) {
    return { kind: 'timeout' };
  }
  const isWarning = input.isWarning || remainingMs <= warningMs;
  return {
    kind: 'wait',
    isWarning,
    nextCheckInMs: isWarning ? remainingMs : remainingMs - warningMs,
  };
};

export const warningPeriodMs = (warningMs: number, timeoutMs: number): number =>
  Math.min(warningMs, timeoutMs);
